var map = {
	"./BSS_hotkeys.json": 980,
	"./Cyberpunk_hotkeys.json": 981,
	"./DBS_hotkeys.json": 982,
	"./Digimon_hotkeys.json": 983,
	"./FAB_hotkeys.json": 984,
	"./FF_hotkeys.json": 985,
	"./Gundam_hotkeys.json": 986,
	"./Lorcana_hotkeys.json": 987,
	"./Magic_hotkeys.json": 988,
	"./OnePiece_hotkeys.json": 989,
	"./Pokemon_hotkeys.json": 990,
	"./Riftbound_hotkeys.json": 991,
	"./SWU_hotkeys.json": 992,
	"./Sorcery_hotkeys.json": 993,
	"./Vanguard_hotkeys.json": 994,
	"./WS_hotkeys.json": 995,
	"./YuGiOh_hotkeys.json": 996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 979;